export const allowedEvents = new Set([
	"return_visit_d7",
	"premium_interest",
	"paste_import_used",
	"calendar_added",
	"settlement_viewed",
	"trip_share_link_created",
	"shared_trip_opened",
	"shared_trip_saved",
	"walk_discovery_open",
	"walk_detail_open",
	"walk_saved",
	"trip_day_adjusted",
	"landing_view",
	"guide_ad_offer_select",
	"guide_ad_request",
	"guide_ad_impression",
	"guide_ad_no_fill",
	"guide_ad_error",
	"airport_source_select",
	"route_result_view",
	"arrival_branch_view",
	"arrival_card_save",
	"offline_card_open",
	"arrival_card_share",
	"arrival_card_export",
	"route_change_seen",
	"airport_edition_return",
	"official_source_open",
	"correction_submit",
	"trip_create_start",
	"trip_created",
	"trip_dashboard_open",
	"trip_setup_open",
	"trip_section_view",
	"trip_section_open",
	"trip_next_action",
	"itinerary_item_added",
	"itinerary_template_added",
	"itinerary_manual_open",
	"itinerary_all_added",
	"checklist_toggled",
	"budget_expense_added",
	"personal_fare_note_added",
	"today_mode_open",
	"trip_share",
	"trip_export",
	"trip_import",
	"trip_clone",
]);
